import { backendServices } from '../services';
import { AddNewLine, IsNotUndefinedNullOrEmpty, IsUndefinedNullOrEmpty } from './string';

export function CreateAddressBlock(address: backendServices.ViewModels.AddressViewModel) {
    const countryIsUSA = IsUndefinedNullOrEmpty(address.Country) || address.Country.toUpperCase() === 'USA';

    let addressBlock = '';

    if (IsNotUndefinedNullOrEmpty(address.Address1)) {
        addressBlock = AddNewLine(addressBlock, address.Address1);
    }

    if (IsNotUndefinedNullOrEmpty(address.Address2)) {
        addressBlock = AddNewLine(addressBlock, address.Address2);
    }

    if (IsNotUndefinedNullOrEmpty(address.Address3)) {
        addressBlock = AddNewLine(addressBlock, address.Address3);
    }

    if (IsNotUndefinedNullOrEmpty(address.Address4)) {
        addressBlock = AddNewLine(addressBlock, address.Address4);
    }

    if (
        IsNotUndefinedNullOrEmpty(address.City) ||
        IsNotUndefinedNullOrEmpty(address.State) ||
        IsNotUndefinedNullOrEmpty(address.PostalCode)
    ) {
        let line = '';
        if (IsNotUndefinedNullOrEmpty(address.City)) {
            line = address.City;
        }
        if (IsNotUndefinedNullOrEmpty(address.State)) {
            line = line + (line.length > 0 ? (countryIsUSA ? ', ' : ' ') : '') + address.State;
        }
        if (IsNotUndefinedNullOrEmpty(address.PostalCode)) {
            line = line + (line.length > 0 ? ' ' : '') + address.PostalCode;
        }

        addressBlock = AddNewLine(addressBlock, line);
    }

    if (IsNotUndefinedNullOrEmpty(address.Country) && !countryIsUSA) {
        addressBlock = AddNewLine(addressBlock, address.Country);
    }

    return addressBlock;
}

